import Vue from 'vue'
import { CONST } from '@/utils/constants'
import store from '@/store'
import { mutationTypes } from './types'
import { Workspaces } from '@/api'
import { extractErrors } from '@/data-extraction/users'

export default {
  resetState: ({ commit }) => {
    commit(mutationTypes.RESET_STATE)
  },
  getAllWorkspaces: async ({ commit }, payload) => {
    const unexpectedError = [ Vue.i18n.translate('default browse workspaces error') ]
    const max = payload.initialLoad ? CONST.ApiRequests.allWorkspacesChunk : store.getters['workspaces/allWorkspacesLength'] + CONST.ApiRequests.allWorkspacesChunk
    commit(mutationTypes.GET_WORKSPACES_PENDING)
    try {
      const response = await Workspaces.getAllWorkspaces(payload.userId, max)
      const workspacesResponse = response.data
      const workspacesList = workspacesResponse['Results']
      const areAllWorkspacesLoaded = workspacesResponse.Total === workspacesResponse.Count
      commit(mutationTypes.GET_WORKSPACES_SUCCESS, workspacesList)
      return { workspacesList, areAllWorkspacesLoaded }
    } catch (err) {
      const errors = extractErrors.workspace(err) || unexpectedError
      commit(mutationTypes.GET_WORKSPACES_FAILURE, errors)
      throw errors
    }
  },
  getNewWorkspaceId: async ({ commit }, userId) => {
    const unexpectedError = [ Vue.i18n.translate('default new workspace error') ]
    commit(mutationTypes.GET_NEW_WORKSPACE_ID_PENDING)
    try {
      const response = await Workspaces.getNewWorkspaceId(userId)
      const id = response.data.Id
      commit(mutationTypes.GET_NEW_WORKSPACE_ID_SUCCESS, id)
      return id
    } catch (err) {
      const errors = extractErrors.workspace(err) || unexpectedError
      commit(mutationTypes.GET_NEW_WORKSPACE_ID_FAILURE, errors)
      throw errors
    }
  }
}
